import type { PreferenceValue } from '@aeris/contracts'

import { usePreference } from './use-preference.ts'

/**
 * Os atalhos de mensagem da vendedora (F297).
 *
 * O gerente da Elite, 20/10: um botão onde a vendedora cria um atalho —
 * título "BOM DIA CLIENTE X", mensagem "bom dia fulano, já estamos
 * abertos…" — e só clica para mandar. É para chamar de uma vez os clientes
 * que não mandaram mensagem. Cada uma tem os seus (preferência de quem está
 * logado); `{nome}` vira o primeiro nome do cliente.
 */

export type QuickReply = PreferenceValue<'inbox.quickReplies'>['items'][number]

export const MAX_QUICK_REPLIES = 30

// Mudou para `@aeris/status-meta` na F308.
export { fillQuickReply } from '@aeris/status-meta'

export const useQuickReplies = (): {
  readonly items: readonly QuickReply[]
  readonly save: (items: readonly QuickReply[]) => void
  readonly error: boolean
} => {
  const preference = usePreference('inbox.quickReplies', { items: [] })
  return {
    items: preference.value.items,
    save: (items) => {
      preference.save({ items: [...items] })
    },
    error: preference.error,
  }
}
